// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1MAJG","infoBtn":"quickbooks_infoBtn__ETfLe","formBox":"quickbooks_formBox__2blhX","formFooter":"quickbooks_formFooter__2SJVL"};